import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import DesktopComponent from './desktop'
import MobileComponent from './mobile'

const ViewComponent = ({ data, application, isLocked, isLoading }) => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)

  return isMobile ? (
    <MobileComponent
      data={data}
      application={application}
      isLocked={isLocked}
      isLoading={isLoading}
    />
  ) : (
    <DesktopComponent data={data} isLocked={isLocked} isLoading={isLoading} />
  )
}

export default ViewComponent
